import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableScrollThumbFn = /* @__PURE__ */ createRecipe('table-scroll-thumb', {}, [])

const tableScrollThumbVariantMap = {}

const tableScrollThumbVariantKeys = Object.keys(tableScrollThumbVariantMap)

export const tableScrollThumb = /* @__PURE__ */ Object.assign(memo(tableScrollThumbFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableScrollThumb',
  __getCompoundVariantCss__: tableScrollThumbFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableScrollThumbVariantKeys,
  variantMap: tableScrollThumbVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableScrollThumbVariantKeys)
  },
  getVariantProps: tableScrollThumbFn.getVariantProps,
})